//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commentService from "./commentService.js";

export default {
  name: "ReplyForm",
  componentName: "ReplyForm",
  components: {},
  props: {
    commentPostID: {
      type: String,
      default: "",
    },
    commentParent: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      authorActive: false,
      emailActive: false,
      commentActive: false,
      btnLoading: false,
      showAlert: false,
      showCancelBtn: true,
    };
  },
  mounted() {
    console.log("bbb");
  },
  methods: {
    tr(key) {
      let temp = key.split(".");
      if (temp.length == 2) {
        return window.$apTranslations[temp[0]][temp[1]];
      }
      if (temp.length == 3) {
        return window.$apTranslations[temp[0]][temp[1]][temp[2]];
      }
      return "";
    },
    onInputLeaveComment(e) {
      if (e.target.value) {
        e.target.className = "touched";
      } else {
        e.target.className = "";
      }
    },
    doLeaveCommentSubmit(e) {
      // input 添加 doLeaveCommentSubmit
      const rootDiv = e.target.parentElement.parentElement;
      const inputArr = rootDiv.getElementsByTagName("input");
      let inputEl;
      for (let i = 0; i < inputArr.length; i++) {
        inputEl = inputArr[i];
        inputEl.className = "touched";
      }
      inputEl = rootDiv.getElementsByTagName("textarea")[0];
      inputEl.className = "touched";

      const emailReg = /^\w+@+[0-9a-zA-Z]+\.(com|com.cn|edu|hk|cn|net)$/;
      const emailValue = this.$refs.emailInput.value;
      if (
        this.$refs.nameInput.value != "" &&
        this.$refs.commentInput.value &&
        emailValue &&
        emailReg.test(emailValue)
      ) {
        this.doSubmit();
      }
    },
    doSubmit() {
      this.btnLoading = true;
      const url = "/wp" + this.$refs.leaveCommentForm.getAttribute("action");

      const data = {
        author: this.$refs.nameInput.value,
        email: this.$refs.emailInput.value,
        comment: this.$refs.commentInput.value,
        comment_post_ID: this.commentPostID,
        comment_parent: this.commentParent,
        url: location.host,
      };
      commentService
        .submitComment(url, data)
        .then((res) => {
          this.btnLoading = false;
          const resData = res.data;
          if (typeof resData === "string") {
            var errorMsg = resData.select(/^\s*<p>(.+?)<\/p>\s*$/, 1);
            if (errorMsg) {
              console.log(errorMsg);
              // $.msg.alert(errorMsg)
            }
          }
        })
        .catch((e) => {
          if (e.response && e.response.status == 409) {
            const str = e.response.data.message.replace(
              /^\s*<p>(.+?)<\/p>\s*$/,
              "$1"
            );
            console.log(e.response.data.message);
            console.log(str);
          }
          this.btnLoading = false;
        });
    },
    doCancel() {},
  },
};
